import axios from "axios";
import Q from '../../../../../../lib/requestModule'
import { paramsSerializer } from "../../../../../../../../utils";

export const fetchLocale = async (props) => {
  const { assetUrl, authToken, apiKey, branch, isPlugin } = props;
  const url = `${assetUrl}/locales`;
  try {
    const headers = {
      api_key: apiKey,
      'Content-Type': 'application/json'
    }
    authToken && (headers['authToken'] = authToken);
    branch && (headers['branch'] = branch);
    let res = {
      data: []
    }
    if (isPlugin) {
      res = await Q({
        action: 'getLocales'
      })
    } else {
      res = await axios({
        method: 'GET',
        url,
        headers,
        paramsSerializer
      });
    }
    const json = await res.data;
    const locales = {};
    json['locales'].forEach(env => locales[env['code']] = env['name']);
    return locales;
  } catch (err) {
    // console.error(err);
    return {};
  }
}
